import styled from 'styled-components';
import PayAtHotelCC from '../assets/hotels/details/pay-at-hotel-cc.svg';

const PayAtHotelCCIcon = styled(PayAtHotelCC as JSX.Element)`
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.color};
  margin: ${props => props.margin};
  /* cursor: pointer; */
`;

export default PayAtHotelCCIcon;
